import React from 'react';
import {getUploadedImagePath} from "@nutastic/nutastic-react-app";
import classnames from "classnames";
import { useNavigation } from '../hooks/useNavigation';

const componentClass = 'highlightBox';

const HighlightBox = ({ isSmall, image, isExternalUrl, url, title }) => {
    const { loadPage } = useNavigation();
    const classes = classnames(componentClass, {
        [`${componentClass}__small`]: isSmall
    });

    const onInternalUrlClick = e => {
        e.preventDefault();
        loadPage(url);
    };

    const Tag = url ? 'a' : 'div';
    const tagProps = url && isExternalUrl ? { href: url, target: '_blank' } : url ? { href: url, onClick: onInternalUrlClick } : {};

    return image ? <Tag {...tagProps} className={classes} style={{ backgroundImage: `url(${getUploadedImagePath(image)})` }}>
        { !isSmall && <div className={`${componentClass}__overlay`} /> }
        { (title && !isSmall) && <span>{ title }</span> }
    </Tag> : null;
};

export default HighlightBox;
